module.exports = __webpack_public_path__ + "static/media/term_ins_system_maintenance.d294defa.svg";